import { FormaPagamentoPorExtenso } from 'src/tipos'

/**
 * O enum `FormaPagamento` do backend não tem `[Description]`, então
 * `formaPagamentoPorExtenso` volta com o próprio nome do enum
 * ("CartaoCredito"). Por isso o dicionário local vem primeiro, e o campo do
 * backend fica como fallback.
 *
 * Extraído de `detalhe/index.tsx` para ser compartilhado com a tela pública do
 * aluno: as duas precisam da mesma tradução, e duas cópias divergiriam na
 * primeira forma de pagamento nova.
 *
 * Vive fora de `design-system-v2` de propósito — é regra de domínio do IPGS,
 * não peça de design system, e importa de `src/tipos` (o que o DS novo não
 * pode fazer).
 */
export const descreverFormaPagamento = (opcao: {
  formaPagamento: string
  formaPagamentoPorExtenso?: string
}): string =>
  FormaPagamentoPorExtenso[
    opcao.formaPagamento as keyof typeof FormaPagamentoPorExtenso
  ] ||
  opcao.formaPagamentoPorExtenso ||
  opcao.formaPagamento
